export class LeaveMapping 
{
    public LeaveMappingId : number;
    public LeaveTypeId : number;
    public LeaveTypeIdS : string;
    public NoOfLeave : Number;
    public CompanyId : number;
    public Year : number;
    public IsActive : boolean;
}